<div class="flex align-items-center" [style.color]="color()">
  <span [attr.title]="instance()[statusType()]">
    {{ instance()[statusType()] | multilanguage | async }}
  </span>
  <faq-status-icon [status]="statusType()" />
</div>
